import React, { useState } from 'react';
import { C } from '../theme';
import { Card, CardTitle, RCard, QuoteBox, Badge, FinInput, BtnPrimary } from '../components/Card';
import { JMML, ROOT_DATA, reduceNum } from '../utils/data';
import useUserStore from '../store/userStore';

function getNameCompatDesc(r1, r2) {
  if (r1 === r2) return 'اسمك واسم جذرك متطابقان — طاقتك الداخلية والخارجية في تناغم تام.';
  if (Math.abs(r1-r2) <= 2) return 'اسمك يدعم جذرك — الطاقتان تتكاملان بشكل جيد.';
  if ((r1+r2) === 10) return 'اسمك وجذرك يكملان بعضهما — كل منهما يُوازن الآخر.';
  return 'اسمك وجذرك مختلفان — قد يوجد توتر بين هويتك الداخلية والخارجية. الكتاب يقترح أن تغيير التوقيع قد يساعد.';
}

export default function JmmlScreen() {
  const [name, setName] = useState('');
  const [result, setResult] = useState(null);
  const { user } = useUserStore();

  function analyze() {
    if (!name.trim()) return;
    let total = 0;
    const breakdown = [];
    for (const ch of name) {
      const val = JMML[ch];
      if (val) { total += val; breakdown.push(`${ch}=${val}`); }
    }
    const finalRoot = reduceNum(total) || 1;
    const rd = ROOT_DATA[finalRoot] || ROOT_DATA[1];
    const userRoot = user?.root_number;
    const compat = userRoot ? (userRoot===finalRoot?'تطابق تام ✦':Math.abs(userRoot-finalRoot)<=2?'توافق قوي':'طاقة مختلفة') : '';
    setResult({ total, breakdown, finalRoot, rd, userRoot, compat });
  }

  return (
    <div>
      <QuoteBox text="الاسم ليس مجرد تزويج للأحرف، بل هو عقد قدري تحمله الحروف بأوزانها العددية" src="جذر الفلك، الجزء الثاني" />
      <Card>
        <CardTitle>🔤 تحليل الاسم بالجُمَّل</CardTitle>
        <p style={{fontSize:12,color:C.text2,marginBottom:14,lineHeight:1.7}}>في علم الجُمَّل، لكل حرف عربي قيمة عددية. جمع قيم حروف اسمك يكشف رقمك الاسمي وطاقته.</p>
        <FinInput value={name} onChange={e=>setName(e.target.value)} placeholder="اكتب اسمك الأول بالعربية..." maxLength={20} style={{marginBottom:8}}/>
        <BtnPrimary onClick={analyze} style={{marginTop:0}}>✦ حلّل الاسم</BtnPrimary>

        {result && (
          <RCard type="pos" style={{marginTop:10}}>
            <div style={{fontSize:14,color:C.gold,fontWeight:600,marginBottom:8,lineHeight:1.8}}>
              "{name}" → {result.breakdown.join(' + ')} = <strong style={{color:C.gold}}>{result.total}</strong> → جذره: <strong style={{fontSize:22,color:C.gold,fontFamily:'Amiri,serif'}}>{result.finalRoot}</strong>
            </div>
            <div style={{fontSize:14,lineHeight:1.75,marginTop:8}}>
              <strong>{result.rd.title}</strong><br/>{result.rd.desc}
            </div>
            {result.userRoot && (
              <div style={{fontSize:12,color:C.text2,marginTop:8,paddingTop:8,borderTop:`1px solid ${C.border}`}}>
                مقارنة مع جذرك ({result.userRoot}): <strong style={{color:C.gold}}>{result.compat}</strong><br/>
                {getNameCompatDesc(result.userRoot, result.finalRoot)}
              </div>
            )}
          </RCard>
        )}
      </Card>

      <Card>
        <CardTitle>جدول قيم الحروف</CardTitle>
        <div style={{overflowX:'auto',borderRadius:10}}>
          <table style={{width:'100%',borderCollapse:'collapse',fontSize:12}}>
            <thead><tr>{['الحرف','القيمة','الحرف','القيمة','الحرف','القيمة'].map((h,i)=><th key={i} style={{background:'#1A1A35',color:C.gold,padding:'10px 12px',textAlign:'right',fontWeight:600,borderBottom:`1px solid ${C.border}`}}>{h}</th>)}</tr></thead>
            <tbody>
              {[['أ',1,'ي',10,'ق',100],['ب',2,'ك',20,'ر',200],['ج',3,'ل',30,'ش',300],['د',4,'م',40,'ت',400],['ه',5,'ن',50,'ث',500],['و',6,'س',60,'خ',600],['ز',7,'ع',70,'ذ',700],['ح',8,'ف',80,'ض',800],['ط',9,'ص',90,'ظ',900]].map((row,i)=>(
                <tr key={i}>{row.map((cell,j)=><td key={j} style={{padding:'10px 12px',borderBottom:`1px solid ${C.border}`,color:typeof cell==='number'?C.text2:C.gold,fontFamily:typeof cell==='string'?'Amiri,serif':'Cairo,sans-serif',fontSize:typeof cell==='string'?16:13}}>{cell}</td>)}</tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
